import type { FC } from 'react';
import { memo } from 'react';

import { type IDateProps } from './FormattedDate'
import { useFormatDate } from './useFormatDate'

export const FormattedShortDate: FC<IDateProps> = memo(
  ({ date = new Date() }) => {
    const formatDate = useFormatDate()

    return (
      <span style={{ whiteSpace: 'nowrap' }}>
        {formatDate(date, {
          month: 'short',
          day: '2-digit',
          year: 'numeric',
        })}
      </span>
    )
  }
)

FormattedShortDate.defaultProps = {
  date: new Date(),
}
FormattedShortDate.displayName = 'FormattedShortDate'
